
import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export default Vue.extend({
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'form',
    },
  },
  render(h, { props, data, children }) {
    return h(
      props.tag,
      mergeData(data, { staticClass: 'slds-form' }),
      children
    );
  },
});
